module.exports = __webpack_public_path__ + "static/media/folder-plus.044def75.svg";